export function resolveTags(options) {
  const tags = [...options.tags].filter(Boolean).map((i) => typeof i === "string" ? { id: i } : i);
  if (options.id)
    tags.unshift({ id: options.id, config: options.config });
  return tags;
}
